import { observer } from 'mobx-react'
import React, { Suspense, useCallback, useEffect } from 'react'
import OverheadExpenseCollection from '../../State/Collections/OverheadExpenseCollection'
import Papa from 'papaparse'
import download from 'downloadjs'

import PageHeader from '../Layout/PageHeader'
import HeaderButton from '../../Components/ui/HeaderButton'
import { canEditOverheadExpenses } from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'

const overheadExpenseColumns = [
    {
        id: 'name',
        label: 'Name',
        value: (expense) => expense.name || '',
    },
    {
        id: 'value',
        label: 'Cost',
        value: (expense) => expense.value || '',
    },
    {
        id: 'costCentre',
        label: 'Cost Centre',
        value: (expense) => expense.costCentre?.name || '',
    },
    {
        id: 'startDate',
        label: 'Start Date',
        value: (expense) =>
            expense.startDate
                ? new Date(expense.startDate).toLocaleDateString()
                : '',
    },
    {
        id: 'endDate',
        label: 'End Date',
        value: (expense) =>
            expense.endDate
                ? new Date(expense.endDate).toLocaleDateString()
                : '',
    },
    {
        id: 'hasRepeat',
        label: 'Repeats',
        value: (expense) => (expense.hasRepeat ? 'Yes' : 'No'),
    },
    {
        id: 'repeatQuantity',
        label: 'Repeat Quantity',
        value: (expense) => expense.repeatQuantity || '',
    },
    {
        id: 'repeatUnit',
        label: 'Repeat Unit',
        value: (expense) => expense.repeatUnit || '',
    },
]

const downloadCSV = () => {
    const rows = [overheadExpenseColumns.map((col) => col.label)]

    OverheadExpenseCollection.activeOverheads.forEach((expense) => {
        rows.push(overheadExpenseColumns.map((col) => col.value(expense)))
    })

    download(Papa.unparse(rows), 'overhead-expenses.csv', 'text/csv')
}

export default observer(({ extraContent }) => {
    return (
        <PageHeader
            heading={
                <div>
                    <div>{'Overhead Expenses'}</div>
                </div>
            }
            extraContent={
                canEditOverheadExpenses(SessionStore.user) ? (
                    <button
                        className="page-header__button--primary add-org-hol-button plus-btn"
                        onClick={() => {
                            const ph = OverheadExpenseCollection.add(
                                { repeatQuantity: 1, repeatUnit: 'months' },
                                { trackUpdates: true }
                            )
                            ph.isNew = true
                        }}
                        style={{ marginTop: '2em' }}
                    >
                        + Add Overhead Expense
                    </button>
                ) : null
            }
            rightButtons={
                <div className="flex items-center gap-2">
                    <HeaderButton
                        label="Export"
                        onClick={() => downloadCSV()}
                        icon={<i className="fa fa-table" />}
                    />
                </div>
            }
        />
    )
})
